import { type VuetifyOptions } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import { de } from 'vuetify/locale';

import { brandColors } from './brand-colors';

const inputDefault = {
  density: 'comfortable',
  variant: 'outlined',
};

export const vuetifyOptionsS21: VuetifyOptions = {
  defaults: {
    VAlert: {
      variant: 'tonal',
      VBtn: {
        variant: 'tonal',
      },
    },
    VAppBar: {
      elevation: 0,
    },
    VAutocomplete: {
      ...inputDefault,
    },
    VBtn: {
      elevation: 0,
    },
    VCard: {
      border: true,
      elevation: 0,
      VCardActions: {
        VBtn: {
          variant: 'flat',
        },
      },
    },
    VCheckbox: {
      color: 'primary',
    },
    VCombobox: {
      ...inputDefault,
      delimiters: [','],
    },
    VDataTable: {
      VBtn: {
        size: 'small',
        VIcon: {
          size: 'x-large',
        },
      },
    },
    VDataTableServer: {
      VBtn: {
        size: 'small',
        VIcon: {
          size: 'x-large',
        },
      },
    },
    VDialog: {
      maxWidth: 500,
      VCard: {
        VCardActions: {
          class: 'justify-end',
        },
      },
    },
    VFileInput: {
      ...inputDefault,
    },
    VMenu: {
      VCard: {
        border: false,
        elevation: 8,
      },
    },
    VSelect: {
      ...inputDefault,
    },
    VSwitch: {
      ...inputDefault,
      color: 'primary',
      inset: true,
    },
    VTextarea: {
      ...inputDefault,
    },
    VTextField: {
      ...inputDefault,
    },
    VTooltip: {
      location: 'bottom center',
    },
  },
  icons: {
    aliases,
    defaultSet: 'mdi',
    sets: {
      mdi,
    },
  },
  locale: {
    fallback: 'en',
    locale: 'de',
    messages: { de },
  },
  theme: {
    themes: {
      dark: {
        dark: true,
        colors: {
          'on-primary': '#FFFFFF',
          'primary': '#da211d',
          ...brandColors,

          // secondary Color
          // secondary: '#424242',
          // 'on-secondary': '#FFFFFF',
        },
      },
      light: {
        dark: false,
        colors: {
          'on-primary': '#FFFFFF',
          'primary': '#da211d',
          ...brandColors,

          // secondary Color
          // secondary: '#dedede',
          // 'on-secondary': '#000000',
        },
      },
    },
    variations: {
      colors: ['primary'],
      darken: 2,
      lighten: 1,
    },
  },
};
